import { render, staticRenderFns } from "./LeadEraseDialog.vue?vue&type=template&id=39e1bf20"
import script from "./LeadEraseDialog.vue?vue&type=script&lang=ts"
export * from "./LeadEraseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports